import Vue from 'vue'

import Web from './layouts/Web.vue'
import Account from './layouts/Account.vue'
import Login from './shared/layouts/Login.vue'

Vue.component('web', Web);
Vue.component('account', Account);
Vue.component('login', Login);